import React, { useContext } from 'react';
import { IndexContext } from "../../context";

const NeedMore = () => {
  const { baseUrl } = useContext(IndexContext);

  return (
    <section className="index-need-more">
      <h2 className="index-need-more-h2">Need more?</h2>
      <div className="index-need-more-item">
        <svg width="34px" height="34px" className="svg-sprite index-need-more-icon">
          <use href={`${baseUrl}/public/images/shapes.svg?v=#plane-left`}/>
        </svg>
        <div>
          <h3 className="index-need-more-h3">Add more Aircraft &amp; Resources</h3>
          <p className="index-need-more-text">
            for just
            <span className="index-need-more-price">$5</span>
            per month
          </p>
        </div>
      </div>
      <div className="index-need-more-item">
        <svg width="29px" height="38px" className="svg-sprite index-need-more-icon">
          <use href={`${baseUrl}/public/images/shapes.svg?v=#pin`}/>
        </svg>
        <div>
          <h3 className="index-need-more-h3">Add more locations</h3>
          <p className="index-need-more-text">
            for just
            <span className="index-need-more-price">$10</span>
            per month
          </p>
        </div>
      </div>
    </section>
  );
};

export default NeedMore;
